<template>
  <v-layout align-center>
    <v-flex xs10 offset-xs1 lg4 offset-lg4>
      <div class="white elevation-2">
        <v-toolbar flat dense dark>
          <v-toolbar-title>Registro</v-toolbar-title>
        </v-toolbar>
        <div class="pl-4 pr-4 pt-2 pb-2">
          <form name="register-form" autocomplete="off">
            <v-text-field
              prepend-icon="account_circle"
              name="name"
              v-model="name"
              label="Nombre"
              required
            ></v-text-field>
            <v-text-field
              prepend-icon="person"
              name="name"
              v-model="fullName"
              label="Nombre completo"
              required
            ></v-text-field>
            <v-text-field
              prepend-icon="lock"
              name="password"
              type="password"
              label="Contraseña"
              v-model="password"
              required
            ></v-text-field>
          </form>
          <v-btn
            dark
            @click="register">Registrarse</v-btn>
        </div>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
/* eslint-disable */
import AuthenticationService from '@/services/AuthenticationService'
export default {
  data () {
    return {
      name: '',
      fullName: '',
      password: ''
    }
  },
  methods: {
    async register () {
      try{
        await AuthenticationService.register({
          name: this.name,
          fullName: this.fullName,
          password: this.password
        })
        this.$router.push('/signin')
      }catch(err){
        console.log(err)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/signup/SignUp.vue